export default __webpack_public_path__ + "static/media/sma_logo.d3cb8b24.png";